export const SECTION_TITLE_DISTRIBUTOR = 'Distributor';
export const SECTION_SUB_TITLE_PRICELIST = 'Pricelist';
export const VIEW_ALL_LINK_TEXT = (brand: string) => `View all ${brand} Cars`;
